import { Modal, Form, Input, InputNumber, Select, Button, DatePicker } from "antd";

export default function TransactionForm({
  addTransaction,
  open,
  setOpen,
  defaultType,
}) {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    await addTransaction({
      ...values,
      type: values.type.toLowerCase(),
      date: values.date.format("YYYY-MM-DD"),
    });

    form.resetFields();
    setOpen(false);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          form.setFieldsValue({ type: defaultType || "" });
          setOpen(true);
        }}
        style={{ marginTop: "20px", marginBottom: "20px" }}
      >
        Add Transaction
      </Button>

      <Modal open={open} footer={null} onCancel={() => setOpen(false)}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="name"
            label="Transaction Name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="amount"
            label="Amount"
            rules={[{ required: true }]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            name="type"
            label="Type"
            rules={[{ required: true }]}
          >
            <Select
              options={[
                { value: "income", label: "Income" },
                { value: "expense", label: "Expense" },
              ]}
            />
          </Form.Item>

          <Form.Item
            name="date"
            label="Date"
            rules={[{ required: true }]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>

          <Button htmlType="submit" type="primary" block>
            Submit
          </Button>
        </Form>
      </Modal>
    </>
  );
}